import React, { FormEvent, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SectionName } from '../App';
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import Notification from '../components/Notification';

interface FooterProps {
 scrollToSection: (section: SectionName) => void;
}

interface FormData {
 name: string;
 email: string;
 phone: string;
}

const Footer: React.FC<FooterProps> = ({ scrollToSection }) => {
 const currentYear = new Date().getFullYear();
 const [formData, setFormData] = useState<FormData>({
   name: '',
   email: '',
   phone: '',
 });
 const [isSubmitting, setIsSubmitting] = useState(false);
 const [submitMessage, setSubmitMessage] = useState('');
 const [isVisible, setIsVisible] = useState(false);

 const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   const { name, value } = e.target;
   setFormData((prevData) => ({
     ...prevData,
     [name]: value,
   }));
 };

 const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
   e.preventDefault();
   setIsSubmitting(true);
   setSubmitMessage('');
   setIsVisible(false);

   try {
     const response = await axios.post(
       `${process.env.REACT_APP_SERVER_URI}/api/newsletter/subscribe`,
       formData,
       {
         headers: {
           'Content-Type': 'application/json',
         },
       }
     );

     if (response.status === 201) {
       setSubmitMessage('Thank you for subscribing!');
       setIsVisible(true);
       setFormData({ name: '', email: '', phone: '' });
     } else {
       setSubmitMessage('An error occurred. Please try again.');
       setIsVisible(true);
     }
   } catch (error) {
     console.error('Subscription error:', error);
     setSubmitMessage('An error occurred. Please try again.');
     setIsVisible(true);
   } finally {
     setIsSubmitting(false);
   }
 };

 return (
   <footer className="bg-gradient-to-b from-[#2C5E3B] to-[#1C3F26] text-white">
     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
       {/* Bottom bar */}
       <div className="mt-8 pt-8 border-t border-green-700/20 text-center">
         <p className="text-green-200 mb-2">
           &copy; {currentYear} EcoFeed Plastics. All rights reserved.
         </p>
         {/* <p className="text-green-300 text-sm">
           Developed by <a 
             href="https://eugeneskom.com" 
             target="_blank" 
             rel="noopener noreferrer" 
             className="hover:text-white transition-colors underline"
           >
             Eugene Skomorokhov
           </a>
         </p> */}
       </div>
     </div>
   </footer>
 );
};

export default Footer;